import React from 'react'

export default function LogoNoText({
  className = 'text-black',
  width,
  height
}: {
  className?: string
  width: number
  height: number
}) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.5015 0C6.93954 0 0 6.93995 0 15.5015C0 24.063 6.93954 31 15.5015 31C24.0634 31 31 24.0601 31 15.5015C31 6.94288 24.0634 0 15.5015 0ZM15.5059 3.23362C20.864 3.23362 25.4582 6.44602 27.3791 11.01C27.6086 11.5638 27.6087 12.186 27.3793 12.7399C27.15 13.2937 26.7101 13.7338 26.1563 13.9633C26.1241 13.9765 26.0919 13.9897 26.059 14.0014C22.6808 15.2529 19.1063 15.8913 15.5037 15.8864C11.7959 15.8921 8.11875 15.216 4.65563 13.8916C4.41268 13.8004 4.19006 13.6623 4.0005 13.4851C3.81094 13.3079 3.65815 13.0951 3.55085 12.8588C3.44355 12.6225 3.38384 12.3674 3.37514 12.1081C3.36644 11.8487 3.40892 11.5902 3.50014 11.3473V11.3407C3.50255 11.3321 3.50573 11.3238 3.50966 11.3158C5.35596 6.59017 10.0321 3.23362 15.5059 3.23362ZM15.5059 27.601C9.98671 27.601 5.2879 24.1954 3.53015 19.4361C3.16937 18.4563 4.13533 17.5006 5.1591 17.8211C8.50737 18.8639 11.9946 19.3924 15.5015 19.3885C19.0112 19.3918 22.5012 18.8621 25.8519 17.8175C26.8764 17.4977 27.8409 18.4534 27.4764 19.4324C25.7158 24.1888 21.0191 27.5973 15.5007 27.5973"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}
